import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import Home from "./views/Home.vue";
import Fees from "./views/Fees.vue";
import Track from "./views/Track.vue";
import Orders from "./views/Orders.vue";
import Billing from "./views/Billing.vue";
import SubmitId from "./views/SubmitId.vue";
import TnumItemList from "./views/TnumItemList.vue";

Vue.use(Router);

function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Login,
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
    },
    {
      path: "/tnum-item-list",
      component: TnumItemList,
    },
    {
      path: "/declare-excel/cn",
      component: loadView("DeclareCn"),
    },
    {
      path: "/declare-excel",
      component: loadView("Declare"),
    },
    {
      path: "/track/:tnum/:year?",
      name: "track",
      component: loadView("Track"),
    },
    {
      path: "/fees/:region?/:method?",
      name: "fees",
      component: Fees,
    },
    {
      path: "/orders",
      name: "orders",
      component: Orders,
    },
    {
      path: "/billing",
      name: "billing",
      component: Billing,
    },
    {
      path: "/track-cn/:tnum",
      component: loadView("TrackCn"),
    },
  ],
});
